import { useCreateLifeAreaSection } from 'features/life-areas/hooks/use-create-life-area-section';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Target } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { ID } from 'shared/types/id';

export type LifeAreaTasksContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'ref'
> & {
  onClose?: () => void;
  lifeAreaId?: ID;
};

export const LifeAreaTasksContextMenu: React.FC<
  LifeAreaTasksContextMenuProps
> = ({ referenceElement, location, position, onClose, lifeAreaId }) => {
  const { t } = useTranslation();

  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const createSection = useCreateLifeAreaSection(lifeAreaId);

  const close = () => onClose?.();

  const onCreateSection = () => {
    createSection();
    close();
  };

  const onAddGoal = () => {
    openCreateGoalDialog({ lifeAreaId });
    close();
  };

  return (
    <PopupMenu
      referenceElement={referenceElement}
      location={location}
      position={position}
      onOutside={close}
    >
      <PopupMenuList>
        <PopupMenuListItem>
          <PopupMenuButton onClick={onAddGoal} start={<Icon icon={Target} />}>
            {t('context-menus.goal.action-plan.labels.add-sub-goal')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onCreateSection}
            start={<Icon icon={Section} />}
          >
            {t('context-menus.goal.action-plan.labels.add-section')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
